import { render, staticRenderFns } from "./TheSimpleLayout.vue?vue&type=template&id=c2487768&"
import script from "./TheSimpleLayout.vue?vue&type=script&lang=js&"
export * from "./TheSimpleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports